import { render } from "./TarifsIcon.vue?vue&type=template&id=3d92df66"
import script from "./TarifsIcon.vue?vue&type=script&lang=js"
export * from "./TarifsIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__